module.exports = __webpack_public_path__ + "abd95c9bbc3b8e14d05ad233d4c79580.svg";